import { render } from "./createLeads.vue?vue&type=template&id=390fa4aa"
import script from "./createLeads.vue?vue&type=script&lang=js"
export * from "./createLeads.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__